export default function ItemTable({ tamanho, children, className }) {
    return (
        <td className={`py-[0.625rem] text-tbody1 font-normal font-['Roboto'] flex items-center ${tamanho ? "w-" + tamanho : ""} ${className}`}>
            {(children == null || children == "no_value") ? "-" : children}
        </td>
    )
}
